// src/constants.ts
var ONE_SECOND = 1e3;
var THREE_SECONDS = 3 * ONE_SECOND;
var FIVE_SECONDS = 5 * ONE_SECOND;
var TEN_SECONDS = 10 * ONE_SECOND;
var FIFTEEN_SECONDS = 15 * ONE_SECOND;
var THIRTY_SECONDS = 30 * ONE_SECOND;
var MINUTE_IN_SECONDS = 60;
var HOUR_IN_SECONDS = 3600;
var DATE_FORMATS = {
  default: "YYYY-MM-DDTHH:mm:ss",
  default_with_miliseconds: "YYYY-MM-DDTHH:mm:ss.SSS"
};
var langTags = {
  en: "en",
  pt: "pt-BR",
  pe: "es-PE",
  ca: "en-CA",
  cl: "es-CL"
};
var SESSION_COOKIE_NAME = "token1";
var SESSION_COOKIE_EXTRA_SECONDS = 900;

export {
  ONE_SECOND,
  THREE_SECONDS,
  FIVE_SECONDS,
  TEN_SECONDS,
  FIFTEEN_SECONDS,
  THIRTY_SECONDS,
  MINUTE_IN_SECONDS,
  HOUR_IN_SECONDS,
  DATE_FORMATS,
  langTags,
  SESSION_COOKIE_NAME,
  SESSION_COOKIE_EXTRA_SECONDS
};
